import { render, staticRenderFns } from "./LearningTools.vue?vue&type=template&id=72da5b54&scoped=true&"
import script from "./LearningTools.vue?vue&type=script&lang=js&"
export * from "./LearningTools.vue?vue&type=script&lang=js&"
import style0 from "./LearningTools.vue?vue&type=style&index=0&id=72da5b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da5b54",
  null
  
)

export default component.exports